// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { User } from "../flow/types";
import axios from "axios";

 
export default function (state: User = initialState.user, action: any) {
    let user = { ...state};
    switch (action.type) {
        case ActionTypes.LOGIN + ActionTypes.FULFILLED:
            let data = action.payload.data;
            let representative = { ...data.representative}
            user.representative = representative;
            user.firstName = data.firstName;
            user.lastName = data.lastName;
            user.activeTotalPoints = data.activeTotalPoints;
            user.accessToken = data.accessToken;
            user.expiresIn = data.expiresIn;
            user.tokenType = data.tokenType;
            user.refreshToken = data.refreshToken;
            user.isAuthenticated = data.isAuthenticated;
            user.id = data.id;
            user.email = data.email;
            user.phone = data.phone;
            user.mobile = data.mobile;
            user.address1 = data.address1;
            user.address2 = data.address2;
            user.address3 = data.address3;
            user.address4 = data.address4;
            user.postCode = data.postCode;
            user.regionId = data.regionId;
            user.titleId = data.titleId;
            user.organization = data.organization;
            user.imageUrl = data.imageUrl;
            user.createdAt = data.createdAt;
            user.totalOrdersCount = data.totalOrdersCount;
            user.activeTotalPoints = data.activeTotalPoints;
            // culture is the locale to connect merlin localization (customer.culture) to the shop's localization (customer.locale)
            user.locale = data.culture; // old was (data.locale)
            user.isNativeCustomer = data.isNativeCustomer === undefined ? false : data.isNativeCustomer;
            user.regionName = data.regionName;
            user.isNewsletterSubscriber = data.isNewsletterSubscriber;
            user.userId = data.userId;
            user.referralCode = data.referralCode;
            axios.defaults.headers.common['userId'] = data.userId;
            axios.defaults.headers.common['Authorization'] = user.accessToken;
           //console.log("axios", axios.defaults.headers.common);
            return user;
        case ActionTypes.FORGOT_PASSWORD + ActionTypes.FULFILLED:
            user.isPasswordReset = action.payload.data === true;
            return user;
        case ActionTypes.FORGOT_PASSWORD + ActionTypes.REJECTED:
        case ActionTypes.FORGOT_PASSWORD + ActionTypes.PENDING:
            user.isPasswordReset = false;
            return user;
        case ActionTypes.REGISTER + ActionTypes.FULFILLED:
            user.isAccountCreated = action.payload.data.success === true;
            return user;
        case ActionTypes.REGISTER + ActionTypes.REJECTED:
        case ActionTypes.REGISTER + ActionTypes.PENDING:
            user.isAccountCreated = false;
            return user;
        case ActionTypes.SAVE_PROFILE + ActionTypes.FULFILLED:
            const savedUser = action.payload.data;
            user.isProfileSaved = savedUser ? true : false;
           // debugger;
            if (user.isProfileSaved) {
               
                user.firstName = savedUser.firstName;
                user.lastName = savedUser.lastName;
                user.email = savedUser.email;
                user.phone = savedUser.phone;
                user.mobile = savedUser.mobile;
                user.address1 = savedUser.address1;
                user.address2 = savedUser.address2;
                user.address3 = savedUser.address3;
                user.address4 = savedUser.address4;
                user.postCode = savedUser.postCode;
                user.regionId = savedUser.regionId;
                user.titleId = savedUser.titleId;
                user.organization = savedUser.organization;
                user.imageUrl = savedUser.imageUrl;
                // culture is the locale to connect merlin localization (customer.culture) to the shop's localization (customer.locale)
                user.locale = savedUser.culture; // old was savedUser.locale
               // axios.defaults.headers.common['locale'] = user.locale;
                
            }
            return user;
        case ActionTypes.SAVE_GUEST_PROFILE:
            const newLocale = action.payload;
            user.locale = newLocale;
            //axios.defaults.headers.common['locale'] = newLocale;
            return user;
        case ActionTypes.SAVE_PROFILE + ActionTypes.REJECTED:
        case ActionTypes.SAVE_PROFILE + ActionTypes.PENDING:
            user.isProfileSaved = false;
            return user;

        case ActionTypes.CHECK_CUSTOMER_EXISTS + ActionTypes.FULFILLED:
            user.isCustomerExists = action.payload.data === true;
            return user;
        case ActionTypes.CHECK_CUSTOMER_EXISTS + ActionTypes.REJECTED:
            user.isCustomerExists = false;
            return user;
        case ActionTypes.RESET_CHECK_CUSTOMER_EXISTS:
            user.isCustomerExists = undefined;
            return user;
        case ActionTypes.LOGOUT + ActionTypes.FULFILLED:
            let currentRepresentative = user.representative;
            user = new User(currentRepresentative);
            user.isAuthenticated = false;
            user.representative = currentRepresentative
            user.accessToken = "";
            user.isNewsletterSubscriber = false;
            axios.defaults.headers.common['Authorization'] = "";
            axios.defaults.headers.common['userId'] = "";
            return user;
        case ActionTypes.RESET_PASSWORD_CLEAR:
            user.isPasswordReset =false;
            return user;
        case ActionTypes.GET_ACTIVE_SETTINGS + ActionTypes.FULFILLED: //"_FULFILLED":
            
            if (action.payload.data.isValidSession === false) {
                user = new User();
                user.isAuthenticated = false;
                user.accessToken = "";
                user.isNewsletterSubscriber = false;
                user.representative = currentRepresentative
                axios.defaults.headers.common['Authorization'] = "";
                axios.defaults.headers.common['userId'] = "";
            }
            user.representative = action.payload.data.defaultRepresentative
            return user;
        case ActionTypes.NEWSLETTER_SUBSCRIBE + ActionTypes.FULFILLED: //"_FULFILLED":
            if (action.payload.data && action.payload.data.isSuccess) {
                user.isNewsletterSubscriber = action.payload.data.shouldSubscribe;
            }
            return user;
        case ActionTypes.LOGOUT + ActionTypes.REJECTED:
        case ActionTypes.CHECK_SESSION + ActionTypes.REJECTED:
        case ActionTypes.LOGIN + ActionTypes.REJECTED:
        case ActionTypes.GET_FEATURED_PRODUCTS + ActionTypes.REJECTED:
        case ActionTypes.GET_PRODUCTS + ActionTypes.REJECTED:
        case ActionTypes.GET_GROUPS + ActionTypes.REJECTED:
        case ActionTypes.GET_RECOMMENDED_PRODUCTS + ActionTypes.REJECTED:
        case ActionTypes.GET_RELATED_PRODUCTS + ActionTypes.REJECTED:
        case ActionTypes.GET_PRODUCT + ActionTypes.REJECTED:
        case ActionTypes.GET_ACTIVE_SETTINGS + ActionTypes.REJECTED:
        case ActionTypes.BUILD_CHECKOUT_SALE + ActionTypes.REJECTED:
        case ActionTypes.GET_ACTIVE_SLIDER_ITEMS + ActionTypes.REJECTED:
        case ActionTypes.GET_ORDER + ActionTypes.REJECTED:
        case ActionTypes.GET_ORDERS + ActionTypes.REJECTED:
        case ActionTypes.NEWSLETTER_SUBSCRIBE + ActionTypes.REJECTED:
        case ActionTypes.ORDER_CHECKOUT + ActionTypes.REJECTED:
        case ActionTypes.GET_CART + ActionTypes.REJECTED:
            if (action.payload.response.status === 401) {
                
                let currentRepresentative = user.representative;
                currentRepresentative.showContanctHeadOfficeMessage = false;
                user = new User();
                user.isAuthenticated = false;
                user.accessToken = "";
                user.isNewsletterSubscriber = false;
                user.representative = currentRepresentative
                //user.locale = "en-GB"
                axios.defaults.headers.common['Authorization'] = "";
                axios.defaults.headers.common['userId'] = "";
                return user;
            }
            return state;
          
        case ActionTypes.ORDER_CHECKOUT + ActionTypes.FULFILLED:
            if (action.payload.data.isSuccess) {
                user.totalOrdersCount = action.payload.data.totalOrdersCount; 
                user.activeTotalPoints = action.payload.data.activeTotalPoints
            }
            return user;
        case ActionTypes.GET_CUSTOMER_REFERRAL_CODE + ActionTypes.FULFILLED:
            user.referralCode = action.payload.data
            return user;
        case ActionTypes.CREATE_CUSTOMER_REFRRAL_CODE + ActionTypes.FULFILLED:
            user.referralCode = action.payload.data
            return user;
        default:
            return state;
    }
}
